import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Logo from '../../../components/atoms/logo/Logo'
import Screen from '../../../components/molecules/screen/Screen'
import routes from '../../../config/routes'
import { useProfile } from '../../../modules/auth/hooks'
import { isProfileCompleted } from '../../../modules/auth/utils'
import { Geolocation as GeolocationService } from '../../../modules/geolocation/service'
import { Notifications as NotificationsService } from '../../../modules/notifications/service'
import { ILocationState } from '../../../types/app.types'
import styles from './SplashScreen.module.css'

const SplashScreen = () => {
  const location = useLocation()
  const { data: user, isLoading, isError } = useProfile()
  const [geolocationState, setGeolocationState] = React.useState('pending')
  const isLogged = !!user && !isLoading && !isError
  const profileCompleted = isProfileCompleted({ user })

  React.useEffect(() => {
    GeolocationService.getGeolocationState()
      .then((state) => {
        setGeolocationState(state)
      })
      .catch((error) => {
        console.info(error)
        setGeolocationState('denied')
      })
  }, [])

  if ((!user && isLoading && !isError) || geolocationState === 'pending') {
    return (
      <Screen hasDecorator decoratorSize="large">
        <div className={styles.container}>
          <Logo className={styles.logo} size="m" />
        </div>
      </Screen>
    )
  }

  if (!isLoading && !user) {
    return <Navigate to={routes.welcome + location.search} state={{ from: location }} replace />
  }

  if (isLogged && !profileCompleted) {
    return <Navigate to={routes.onboarding.home + location.search} state={{ from: location }} replace />
  }

  if (isLogged && !user.email_verified) {
    return <Navigate to={routes.validation.emailPending + location.search} state={{ from: location }} replace />
  }

  if (isLogged && !user.validated) {
    return <Navigate to={routes.validation.coworkingPending + location.search} state={{ from: location }} replace />
  }

  if (isLogged && GeolocationService.getState() !== 'granted') {
    return <Navigate to={routes.geolocation + location.search} state={{ from: location }} replace />
  }

  if (isLogged && NotificationsService.getState() === 'default') {
    return <Navigate to={routes.notifications + location.search} state={{ from: location }} replace />
  }

  const from = (location?.state as ILocationState)?.from?.pathname
  return <Navigate to={(from || routes.home) + location.search} replace />
}

export default React.memo(SplashScreen)
